import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

/**
 * 
 * @param { open(boolean), onClose(function), message(string)
 *          , severity(string)(type:"error","warning","info","success") } props  
 * @returns 
 * @author minjlee
 * @since 2023. 03.10
 * @version 0.1
 */
const USnackbar = (props) => {
  return (
    <>
      <Snackbar open={props.open} autoHideDuration={3000} onClose={props.onClose}>
        <Alert onClose={props.onClose} severity={props.severity} sx={{ width: '100%' }}>
          {props.message}
        </Alert>
      </Snackbar>
    
    </>
  )
}

export default USnackbar;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
      